module.exports = __webpack_public_path__ + "static/images/copy.bJF3GlG.svg";